import { defineRows, FieldTemplate, TemplateRow } from '../../../app/components/fields-template/field-template';
import type { entityTypes } from '../entitytypes';
import { BASE_ROWS } from './base';

type BlastET = (typeof entityTypes)['blast'];

export class BlastTemplate implements FieldTemplate {
    rows: TemplateRow[] = defineRows<BlastET>([
        ...BASE_ROWS,
        {
            type: 'row',
            children: [
                { type: 'field', fieldKey: 'person_id', fieldGroup: 'planningData', classes: 'col-24 col-md' },
                { type: 'field', fieldKey: 'contacttelefoon', fieldGroup: 'planningData', classes: 'col-24 col-md' },
                { type: 'field', fieldKey: 'verkeersmaatregel', fieldGroup: 'planningData', classes: 'col-24 col-md' },
                {
                    type: 'field',
                    fieldKey: 'leverancier_verkeersmaatregel',
                    fieldGroup: 'planningData',
                    classes: 'col-24 col-md',
                },
            ],
        },
        {
            type: 'row',
            children: [
                { type: 'field', fieldKey: 'behoefteM1', fieldGroup: 'pheData', classes: 'col-24 col-md' },
                { type: 'field', fieldKey: 'behoefteM2', fieldGroup: 'pheData', classes: 'col-24 col-md' },
            ],
        },
    ]);
}
